import { assetPackIds } from "nemuru-components";
import { THEME_NAMES } from "./config";

export const peralbaTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.peralba,
  logoUrl: "https://cdn.nemuru.com/assets/logos/peralba-logo.svg",
  palette: {
    primary: {
      main: "#7A212E",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#B4252D",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#F6303E",
      contrastText: "#ffffff",
      accent: "#c8102e",
      imageBackgroundOpacity: 0.85,
    },
    text: {
      title: "#353430",
      primary: "#353430",
      secondary: "#666",
    },
    status: {
      active: "#4ac687",
      approved: "#349a65",
      analysing: "#00529c",
      sent: "#00274a",
      cancelled: "#d8d8d8",
      denied: "#e81e26",
    },
    info: {
      main: "#c8102e",
      contrastText: "#ffffff",
      light: "#d6dbdf",
    },
    warning: {
      main: "#f8cd51",
      contrastText: "#ffffff",
      light: "#fff6e7",
    },
    success: {
      main: "#479d38",
      contrastText: "#ffffff",
      light: "rgba(76, 205, 138,0.6)",
    },
    grey: {
      50: "#fafafa",
      100: "#f5f5f2",
      200: "#eae9e6",
      300: "#dad9d6",
      400: "#b6b5b2",
      500: "#969593",
      600: "#6e6d6b",
      700: "#5a5a57",
      800: "#3c3b39",
      900: "#1b1b19",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#E9E9E9",
  customBorderRadius: {
    button: 3,
    paper: 3,
  },
  typography: {
    fontFamily: "Source Sans Pro, sans-serif",
  },
};
